const hasAdblock = () => {
    const el = document.createElement('div');

    el.className = 'afs_ads';
    el.innerHTML = '&nbsp;';
    el.style.width = '1px';
    el.style.height = '1px';
    el.style.position = 'absolute';
    el.style.background = 'transparent';

    document.body.appendChild(el);

    const wasDetected = !document.body.contains(el)
      || el.offsetParent === null
      || el.className !== 'afs_ads'
      || el.innerHTML === ''
      || el.clientHeight === 0;

    document.body.removeChild(el);

    return wasDetected;
};

export default hasAdblock;
